module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "catalog-forecast-dashboard",
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.loading,
      "fixed": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row d-flex align-items-center catalog-forecast-dashboard-header mb-5"
  }, [(_vm.periods.length > 8) ? _c('div', {
    staticClass: "col-auto",
    class: {
      'disable-arrow': _vm.offsetControl === 0
    },
    on: {
      "click": function($event) {
        _vm.updateOffset(-1)
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.periods), function(period, index) {
    return (index >= _vm.offsetControl && index < _vm.offsetControl + 8) ? _c('div', {
      key: index,
      staticClass: "col"
    }, [_c('span', {
      class: (_vm.selectedPeriod.id === period.id ? 'active' : '') + (period.isOpened ? ' open ' : ' '),
      on: {
        "click": function($event) {
          _vm.changePeriod(period)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getDate(period.stampCode, "MMM YY", "month")) + "\n            ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.periods.length > 8) ? _c('div', {
    staticClass: "col-auto",
    class: {
      'disable-arrow': _vm.offsetControl === _vm.periods.length - 8
    },
    on: {
      "click": function($event) {
        _vm.updateOffset(1)
      }
    }
  }, [_vm._m(1)]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "catalog-forecast-dashboard-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.title")))])]), _vm._v(" "), (_vm.selectedPeriod) ? _c('div', [_c('span', {
    staticClass: "catalog-forecast-dashboard-period-title"
  }, [_vm._v(_vm._s(_vm.periodTitle))]), _vm._v(" "), (_vm.zoneGroupsFiltered.length) ? _c('div', {
    staticClass: "mt-5 row d-flex align-items-start catalog-forecast-dashboard-recap"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('PeriodDates', {
    attrs: {
      "period": _vm.selectedPeriod
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col px-5 text-global-progress"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("catalogForecast.globalProgression")) + " :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('span', [_vm._v(_vm._s(_vm.getGlobalValidatePercent()) + "%")])])]), _vm._v(" "), _c('VmProgress', {
    class: (_vm.isLineProgress ? 'line-progress ' : 'circle-progress ') +
      (_vm.getGlobalValidatePercent() === 0 ? ' zero-percent' : ''),
    attrs: {
      "percentage": _vm.getGlobalValidatePercent(),
      "show-text": false,
      "type": _vm.isLineProgress ? 'line' : 'circle',
      "stroke-linecap": 'square',
      "stroke-width": 20,
      "stroke-color": "#747795",
      "track-color": "white"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2"
  })])]), _vm._v(" "), (_vm.canRechallenge) ? _c('div', {
    staticClass: "col-auto"
  }, [_c('ClientColorButton', {
    staticClass: "btn-global-rechallenge mt-3",
    attrs: {
      "rounded": true,
      "background-color": "#F9C53C",
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.openModalAllRechallengeMarkets()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-undo-alt fa-lg"
  })]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.rechallengeMarkets")))])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.zoneGroupsFiltered.length) ? _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry",
      value: ('containerId'),
      expression: "'containerId'"
    }],
    staticClass: "mt-5 row",
    attrs: {
      "item-selector": '.item',
      "origin-left": false,
      "horizontal-order": true
    }
  }, _vm._l((_vm.zoneGroupsFiltered), function(zg) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      key: zg.id,
      staticClass: "col-12 col-md-4 catalog-forecast-dashboard-item item pb-5"
    }, [_c('div', {
      staticClass: "dashboard-header"
    }, [_c('div', {
      staticClass: "row d-flex align-items-center"
    }, [_c('div', {
      staticClass: "col-auto"
    }, [(_vm.canRechallenge) ? _c('ClientColorButton', {
      staticClass: "ml-4",
      attrs: {
        "size": "m",
        "rounded100": true,
        "background-color": "#F9C53C",
        "color": "#fff"
      },
      on: {
        "click": function($event) {
          _vm.openModalRechallengeMarkets(zg.brandZonesDashboard)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-undo-alt fa-lg"
    })]) : _vm._e(), _vm._v(" "), (!_vm.canRechallenge) ? _c('p', {
      staticClass: "m-0",
      staticStyle: {
        "min-width": "32px"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col d-flex align-items-end justify-content-center"
    }, [_c('span', [_vm._v(_vm._s(zg.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-auto"
    }, [_c('span', [_vm._v(_vm._s(_vm.getValidatedNb(zg.brandZonesDashboard)) + "/" + _vm._s(zg.brandZonesDashboard.length))])])])]), _vm._v(" "), _c('div', {
      staticClass: "dashboard-lines mt-4 mb-4"
    }, _vm._l((zg.brandZonesDashboard), function(brandZone) {
      return _c('div', {
        key: brandZone.zone.id,
        staticClass: "dashboard-line d-flex align-items-center pointer",
        on: {
          "click": function($event) {
            _vm.$router.push({
              path: '/admin/catalog_forecast/market/' + brandZone.zone.periodHasZones[0].id
            })
          }
        }
      }, [_c('span', {
        staticClass: "pastille",
        class: _vm.getStatusStyle(brandZone.zone.periodHasZones[0])
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(brandZone.zone.name))])])
    }))])
  })) : _vm._e(), _vm._v(" "), (_vm.rechallengeMarketsParams) ? _c('RechallengeMarkets', {
    attrs: {
      "params": _vm.rechallengeMarketsParams
    },
    on: {
      "success": function($event) {
        _vm.changePeriod(_vm.selectedPeriod, false)
      },
      "close": function($event) {
        _vm.rechallengeMarketsParams = null
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "no-period d-flex align-items-center justify-content-center"
  }, [_vm._v(_vm._s(_vm.$t("catalogForecast.noPeriod")))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-lg"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e79a1f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalogForcast/pages/CatalogForecastDashboard.vue
// module id = 3063
// module chunks = 0